// Merge-variable parser for campaign email templates.
//
// Syntax:
//   {{key}}            - substitute value; if value is empty/missing, render empty string
//   {{key|fallback}}   - substitute value; if value is empty, render the fallback
//
// Unknown keys (not in the values dict) are left literal so stray placeholders
// stay visible to the user. This must stay in sync with the Python parser at
// crm/campaigns/activities.py:_resolve_merge.

const MERGE_RE = /\{\{(\w+)(?:\|([^}]*))?\}\}/g;

export function resolveMergeVars(text: string, values: Record<string, string | undefined>): string {
  if (!text) return text ?? "";
  return text.replace(MERGE_RE, (match, key: string, fallback: string | undefined) => {
    if (!(key in values)) return match;
    const value = values[key];
    if (value) return value;
    return fallback ?? "";
  });
}

// Per-field defaults the variable picker pre-fills as fallback text. Empty
// string means the picker offers no default; the user can still type one.
export const MERGE_FIELD_DEFAULTS: Record<string, string> = {
  first_name: "there",
  last_name: "",
  full_name: "there",
  email: "",
  company: "your company",
  title: "",
  phone: "",
  location: "",
  sender_full_name: "",
  sender_first_name: "",
  sender_email: "",
  sender_company: "",
};

// Build a merge-variable insertion string. Used by the picker to assemble the
// final {{key}} or {{key|fallback}} based on whether the user provided a fallback.
export function buildMergeToken(key: string, fallback?: string): string {
  const trimmed = fallback?.trim();
  return trimmed ? `{{${key}|${trimmed}}}` : `{{${key}}}`;
}
